import { calculateRemindTime, getDateStrBySegment } from '@flowus/common';
import { cx } from '@flowus/common/cx';
import type { DateFormat, SegmentDTO, TimeFormat } from '@next-space/fe-api-idl';
import { TextType } from '@next-space/fe-api-idl';
import type { FC } from 'react';
import { useMemo } from 'react';
import { Icon } from 'src/common/components/icon';

interface Props {
  includeAt?: boolean;
  segment: SegmentDTO;
  className?: string;
  normalClassName?: string;
  dateFormat?: DateFormat;
  timeFormat?: TimeFormat;
}
export const DateValue: FC<Props> = (props) => {
  const { includeAt, segment, dateFormat, timeFormat, className, normalClassName, ...attribute } =
    props;
  const invalid = useMemo(() => {
    const time = calculateRemindTime(segment);
    if (!time) return false;
    return Date.now() - time > 0;
  }, [segment]);
  const dateStr = useMemo(() => {
    const maybeAt = includeAt ? '@' : '';
    return (
      maybeAt +
      getDateStrBySegment(segment, dateFormat, segment.type === TextType.DATETIME, timeFormat)
    );
  }, [dateFormat, includeAt, segment, timeFormat]);

  if (!segment) return null;
  if (segment.reminder) {
    return (
      <span
        {...attribute}
        className={cx(
          'text-red',
          {
            'text-red/70 line-through': invalid,
          },
          className
        )}
      >
        <span className="flex items-center">
          {dateStr}
          <Icon
            name="IcMenuAlarm"
            size="normal"
            style={{
              textDecoration: 'line-through',
            }}
            className={cx('text-red ml-[2px]', {
              'text-red/70': invalid,
            })}
          />
        </span>
      </span>
    );
  }

  return (
    <span {...attribute} className={cx(className, normalClassName)}>
      {dateStr}
    </span>
  );
};
